import React, { useEffect, useState } from 'react';
import API from '../api';
import { differenceInCalendarDays, parseISO } from 'date-fns';

export default function Design() {
  const [rows, setRows]           = useState([]);
  const [dropdowns, setDropdowns] = useState({});
  const [filterStep, setFilterStep]     = useState('');
  const [filterStatus, setFilterStatus] = useState('');

  useEffect(() => {
    (async () => {
      const [rRes, dRes] = await Promise.all([
        API.get('/api/design'),
        API.get('/api/dropdowns'),
      ]);
      setRows(rRes.data||[]);
      setDropdowns(dRes.data||{});
    })();
  }, []);

  if (!rows.length) return <div style={{padding:20}}>Loading design…</div>;

  const header   = rows[0];
  const dataRows = rows.slice(1).filter(r=>r.some(c=>c!==''));
  const now      = new Date();

  const steps    = dropdowns['Process Step'] || [];
  const statuses = dropdowns['Step Status'] || [];

  const filtered = dataRows.filter(r =>
    (!filterStep   || r[header.indexOf('Process Step')] === filterStep) &&
    (!filterStatus || r[header.indexOf('Step Status')]   === filterStatus)
  );

  const sendToQuote = async idx => {
    await API.post(`/api/design/${idx}/send-to-quote`);
    const r2 = await API.get('/api/design');
    setRows(r2.data||[]);
  };
  const approveByFinance = async idx => {
    await API.post(`/api/design/${idx}/approve-by-finance`);
    const r2 = await API.get('/api/design');
    setRows(r2.data||[]);
  };

  return (
    <div style={{padding:20}}>
      <h2>Design</h2>
      <div className="filter-bar">
        <select value={filterStep} onChange={e=>setFilterStep(e.target.value)}>
          <option value="">All Steps</option>
          {steps.map(s=> <option key={s} value={s}>{s}</option>)}
        </select>
        <select value={filterStatus} onChange={e=>setFilterStatus(e.target.value)}>
          <option value="">All Status</option>
          {statuses.map(s=> <option key={s} value={s}>{s}</option>)}
        </select>
      </div>

      <div className="table-container" style={{marginTop:20}}>
        <table>
          <thead>
            <tr>
              {header.map((h,i)=><th key={i}>{h}</th>)}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((row,ri)=>{
              const dueIdx = header.findIndex(h=>/due date/i.test(h));
              let cls=''
              if(dueIdx>=0 && row[dueIdx]){
                const diff = differenceInCalendarDays(parseISO(row[dueIdx]), now);
                cls = diff<0?'overdue':diff<=3?'due-soon':'';}
              return (
                <tr key={ri} className={cls}>
                  {row.map((c,ci)=><td key={ci}>{c}</td>)}
                  <td>
                    {row[header.indexOf('Process Step')]?.startsWith('Quote') &&
                     row[header.indexOf('Step Status')] === 'Confirmed' && (
                      <button className="btn btn-primary" onClick={()=>sendToQuote(ri)}>
                        Send to Quote
                      </button>
                    )}
                    {['Production Job Card','Production Job Card Revision']
                     .includes(row[header.indexOf('Process Step')]) &&
                     row[header.indexOf('Step Status')] === 'Confirmed' && (
                      <button className="btn btn-primary" onClick={()=>approveByFinance(ri)}>
                        Approve by Finance
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
